<template>
	<div class="itembatterie">
		<h1>Angaben zur Person</h1>
		<h2>Geschlecht</h2>
		<v-radio-group v-model="geschlecht" @change="antwortItem('geschlecht', geschlecht)">
			<v-radio value="1" label="weiblich"></v-radio>
			<v-radio value="2" label="männlich"></v-radio>
			<v-radio value="3" label="divers"></v-radio>
		</v-radio-group>
		<h2>Geburtsjahr</h2>
		<p><v-text-field v-model="geburtsjahr" label="Geburtsjahr" @change="antwortItem('geburtsjahr', geburtsjahr)"></v-text-field></p>
		<h2>Schulabschluss</h2>
		<p>Welchen <u>h&ouml;chsten</u> Schulabschluss haben Sie derzeit?</p>
		<v-radio-group v-model="schulabschluss" @change="antwortItem('schulabschluss', schulabschluss)">
			<v-radio value="1" label="Hochschulabschluss, Fachhochschulabschluss"></v-radio>
			<v-radio value="2" label="Allgemeine Hochschulreife (Abitur), Fachhochschulreife (Fachabitur)"></v-radio>
			<v-radio value="3" label="Realschulabschluss, Mittlere Reife"></v-radio>
			<v-radio value="4" label="Mittelschulabschluss, Hauptschulabschluss"></v-radio>
			<v-radio value="5" label="Keinen Abschluss"></v-radio>
		</v-radio-group>
		<h2>Berufliche Stellung</h2>
		<p>In welcher beruflichen Stellung sind Sie derzeit besch&auml;ftigt?</p>
		<v-radio-group v-model="berufsstellung" @change="antwortItem('berufsstellung', berufsstellung)">
			<v-radio value="1" label="Selbstständige/r, Freiberufler/-in"></v-radio>
			<v-radio value="2" label="Beamter/-in (einschl. Richter und Berufssoldaten)"></v-radio>
			<v-radio value="3" label="Angestellte/r"></v-radio>
			<v-radio value="4" label="Arbeiter/in (auch in der Landwirtschaft)"></v-radio>
			<v-radio value="5" label="Auszubildende/-r, Praktikant/-in"></v-radio>
		</v-radio-group>
		<h2>Arbeitsort</h2>
		<p>An welchem Ort arbeiten Sie derzeit &uuml;berwiegend?</p>
		<v-radio-group v-model="arbeitsort" @change="antwortItem('arbeitsort', arbeitsort)">
			<v-radio value="1" label="Betrieb"></v-radio>
			<v-radio value="2" label="Homeoffice"></v-radio>
			<v-radio value="3" label="Mischform aus Betrieb und Homeoffice"></v-radio>
			<v-radio value="4" label="trifft nicht zu"></v-radio>
		</v-radio-group>
		<h2>Berufserfahrung</h2>
		<p>Seit wie vielen Jahren sind Sie berufst&auml;tig?</p>
		<p><v-text-field v-model="berufserfahrung" label="Berufserfahrung (in Jahren)" @change="antwortItem('berufserfahrung', berufserfahrung)"></v-text-field></p>
		<h2>Arbeitszeit</h2>
		<p>Wie viele Stunden arbeiten Sie normalerweise pro Woche?</p>
		<p><v-text-field v-model="arbeitszeit" label="Arbeitszeit (in Stunden)" @change="antwortItem('arbeitszeit', arbeitszeit)"></v-text-field></p>
		<h2>Befristung des Arbeitsverh&auml;ltnisses</h2>
		<p>Falls Sie abh&auml;ngig besch&auml;ftigt sind: Ist Ihr derzeitiges Arbeitsverh&auml;ltnis zeitlich befristet?</p>
		<v-radio-group v-model="befristung" @change="antwortItem('befristung', befristung)">
			<v-radio value="1" label="Befristet"></v-radio>
			<v-radio value="2" label="Unbefristet"></v-radio>
		</v-radio-group>
		<h2>Teamgr&ouml;&szlig;e</h2>
		<p>Wie viele Personen umfasst das Team, in dem Sie gegenw&auml;rtig arbeiten?</p>
		<p><v-text-field v-model="teamgroesse" label="Teamgröße (Anzahl Personen)" @change="antwortItem('teamgroesse', teamgroesse)"></v-text-field></p>
		<h2>Dauer der Teamzugeh&ouml;rigkeit</h2>
		<p><v-text-field v-model="teamdauer" label="Dauer der Teamzugehörigkeit (in Monaten)" @change="antwortItem('teamdauer', teamdauer)"></v-text-field></p>
		<h2>F&uuml;hrungsposition</h2>
		<p>Sind Sie eine F&uuml;hrungskraft mit mindestens einem Mitarbeitenden?</p>
		<v-radio-group v-model="fuehrungsposition" @change="antwortItem('fuehrungsposition', fuehrungsposition)">
			<v-radio value="1" label="ja"></v-radio>
			<v-radio value="2" label="nein"></v-radio>
		</v-radio-group>		
		<h2>Erkl&auml;rung zur Beantwortung der Fragen</h2>
		<p><v-checkbox v-model="vergleich" value="1" label="Ich habe die Fragen gewissenhaft und wahrheitsgemäß beantwortet, so dass meine Angaben für die Bestimmung der Vergleichsgruppe verwendet werden können." @change="antwortItem('vergleich', vergleich)"></v-checkbox></p>
	</div>
</template>
<script>
	export default {
		name: 'Demographie',
		data: function () {
			return {
				antworten: {},
				geschlecht: null,
				geburtsjahr: null,
				schulabschluss: null,
				berufsstellung: null,
				arbeitsort: null,
				berufserfahrung: null,
				arbeitszeit: null,
				befristung: null,
				teamgroesse: null,
				teamdauer: null,
				fuehrungsposition: null,
				vergleich: null,
			}
		},
		methods: {
			antwortItem: function(item, antwort) {
				this.antworten[item] = antwort;
				console.log('demographie.vue');
				console.log(item + ' / ' + antwort);
				console.log(this.antworten);
				this.$emit('demographieAntwort', {item, antwort});
			}
		}
	}
</script>
